import * as Moment from "moment";
import {
  IExternalImageRepository,
  ExternalImageItem,
} from "../../../domain/externalImage";
import { AuthenticatedService } from "../..";
import { IExternalImageStockable } from "../IExternalImageStockable";
import { IExternalImageItemBean } from "./IExternalImageItemBean";
import { ExternalImageSource } from ".";

export class ExternalImageRepository extends AuthenticatedService implements IExternalImageRepository, IExternalImageStockable {
  constructor(private _getToken: () => string) {
    super(_getToken);
  }

  public async getExternalImageItems(patientId: string): Promise<ExternalImageItem[]> {
    if (!patientId) { throw new Error("id is empty!!!"); }
    const url = "/api/patient/" + patientId + "/externalimages";
    const result = await this.get(url);
    const converted = this.toExternalImageItems(patientId, result.data);
    this.stock(converted);
    return converted;
  }

  private toExternalImageItems(patientId: string, beans: IExternalImageItemBean[]): ExternalImageItem[] {
    if (!beans) { return []; }
    return beans.map(bean => this.toExternalImageItem(patientId, bean));
  }

  private toExternalImageItem(patientId: string, bean: IExternalImageItemBean): ExternalImageItem {
    const imageSource = new ExternalImageSource(patientId, bean.id, this._getToken);
    const item = new ExternalImageItem(patientId, bean.id, this.toDate(bean.imageDateTime), imageSource);
    Object.freeze(item);
    return item;
  }

  private toDate(imageDateTime: string): Date {
    if (!imageDateTime) { return null; }
    // 現状ではバックエンドでyyyyMMddHHmmssを指定している
    const imageDate = imageDateTime.substr(0, 8);
    return Moment(imageDate, "YYYYMMDD").toDate();
  }

  private stock(source: ExternalImageItem[]): void {
    for (const s of source) {
      if (!this._stocked[s.patientId]) {
        this._stocked[s.patientId] = {};
      }
      this._stocked[s.patientId][s.id] = s;
    }
  }

  private readonly _stocked: { [key: string]: { [key: string]: ExternalImageItem } } = {};

  public getStockedExternalImage(patientId: string, imageId: string): ExternalImageItem {
    if (!patientId) {
      throw new Error("patientId is empty!!!");
    }
    if (!imageId) {
      throw new Error("imageId is empty!!!");
    }
    return this._stocked[patientId]
      ? this._stocked[patientId][imageId]
      : null;
  }
}
